import { useEffect, useState } from "react";
import { selectCurrentPackageItems, selectedNewPackageTitleData, selectPackageDetailsAction } from "../../features/package/packageSlice";
import { useSelector } from "react-redux";

interface UsePackageFormValidationProps {
    typOfAction: "newPackage" | "updatePackage"
}

export function usePackageFormValidation({ typOfAction }: UsePackageFormValidationProps) {
    
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

    const packageDetailAction = useSelector(selectPackageDetailsAction);
    const currentPackageItems = useSelector(selectCurrentPackageItems);
    const newPackageTitleData = useSelector(selectedNewPackageTitleData);

    const isPackageCupBase =
        typOfAction === "updatePackage" &&
        packageDetailAction.packageType === "special";

    useEffect(() => {
        const hasItems = currentPackageItems.length > 0;

        const isValid = isPackageCupBase
            ? !!(
                    newPackageTitleData.packageName?.trim() &&
                    newPackageTitleData.totalValue > 0 &&
                    newPackageTitleData.discountPercentage != null &&
                    newPackageTitleData.canExceed != null &&
                    hasItems
                )
            : !!(
                    newPackageTitleData.packageName?.trim() &&
                    newPackageTitleData.quantity > 0 &&
                    newPackageTitleData.totalValue > 0 &&
                    hasItems
                );

        setIsSubmitDisabled(!isValid);
    }, [
        isPackageCupBase,
        currentPackageItems,
        newPackageTitleData,
    ]);

    return { isSubmitDisabled };

}